export default "__VITE_ASSET__4389573c__"